import { Assignee } from '../../../shared/interfaces/company';
import { NotificationContent } from './notification-content';

export interface Notifications {
  id: number;
  notification_type: NotificationTypes;
  notification_content: NotificationContent;
  message_data?: Record<string, unknown>;
  message: string;
  title?: string;
  body?: string;
  action_label?: string;
  icon?: string;
  is_read: boolean;
  created_on_utc: string;
  created_by_user: Assignee;
  expiry_text?: string;
}

export enum NotificationTypes {
  SHARE_RECORD = 1,
  CDFI_OUTREACH_GLOBAL = 3,
  CDFI_OUTREACH_GENERAL_MATCHED = 6,
  CDFI_OUTREACH_LEAD = 7,
  CDFI_OUTREACH_LOAN_FORM = 8,
  SHARE_RECORD_NOTE = 9,
  SHARE_DOCUMENT_TO_USER = 10,
  SHARE_DOCUMENT_TO_CONNECTION = 11,
  ORG_SELF_SIGNUP = 12,
  RECORD_VISIBILITY_UPDATED = 13,
  PDM_SHARE_APPROVAL = 14,
  FILE_MALICIOUS_DETECTED = 15,
  SHARE_LEAD_FILE = 16,
  ANNOUNCEMENT = 17,
  LEAD_BUSINESS_UPDATED = 18,
  LEAD_BUSINESS_DELETED = 19,
  CDFI_PROFILE_VIEW = 20,
  USER_PROFILE_VIEW = 21,
  SME_LEAD_ASSIGNED = 22,
  SME_LEAD_STATUS_CHANGED = 23,
  VLF_RECORD_CREATED = 24,
  VLF_LEAD_CLAIMED = 25,
  VLF_LEAD_STATUS_UPDATED = 26,
  VLF_LEAD_WEEKLY_REMINDER = 27,
  VLF_LEAD_UNFUNDED_REALLOCATED = 28,
  VLF_LEAD_TIMEOUT_INFORM_VLF = 29,
  VLF_LEAD_FUNDING_EXPIRY_REMINDER = 30,
  VLF_LEAD_FUNDING_EXPIRED_REALLOCATED = 31,
}

export interface NotificationFormatter {
  title: string;
  body: string;
  actionLabel?: string;
}

export interface NotificationFormatInput {
  notification_type: NotificationTypes;
  message_data?: Record<string, unknown>;
}
